'use client';

import { useState, useEffect } from 'react';

export default function Carousel({ images }) {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-slide functionality (every 3 seconds)
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className='relative w-full max-w-xl mx-auto'>
      {/* Carousel Images */}
      <div className='relative'>
        <div className='overflow-hidden w-full h-48  max-xs:h-36 rounded-lg'>
          <div
            className='flex transition-transform duration-500'
            style={{
              transform: `translateX(-${activeIndex * 100}%)`, // Controls sliding effect
            }}
          >
            {images.map((Image, index) => (
              <div
                key={index}
                className='w-full h-full flex-shrink-0'
                style={{
                  opacity: activeIndex === index ? 1 : 0, // Apply opacity based on activeIndex
                  transition: 'opacity 0.5s ease-in-out', // Ensure smooth fade effect
                }}
              >
                <img
                  src={Image}
                  alt={`Banner ${index + 1}`}
                  className='object-cover w-full h-full rounded-lg'
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Carousel Indicators */}
      <div className='absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2'>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full  ${
              activeIndex === index ? 'bg-blue-500' : 'bg-white'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
